import TextDropdown from 'components/common/TextDropdown/TextDropdown';
import { Option } from 'types/global';
import './SearchOverview.scss';
import { SearchSort, SearchSortField, SearchTarget } from 'types/Search';

interface SearchOverviewProps {
  total: number;
  target: SearchTarget;
  selectedOption: SearchSort;
  onSortChangeHandler: (currentValue: { value: SearchSortField }) => void;
}

const SearchOverview = ({
  total,
  target,
  selectedOption,
  onSortChangeHandler
}: SearchOverviewProps) => {
  const options: Option[] = [
    {
      value: SearchSortField.SCORE,
      label: 'Relevance'
    },
    {
      value: SearchSortField.NAME,
      label: 'Name'
    }
  ];

  return (
    <div className="search-overview">
      <span
        className="search-overview-results"
        style={{ whiteSpace: 'nowrap' }}
      >
        {total.toLocaleString('en-US')} {target.toLocaleLowerCase()} found
      </span>
      <span className="search-overview-sort">
        <TextDropdown
          label="Sort by: "
          name="search-overview-dropdown"
          value={{
            value: selectedOption.field,
            label:
              options.find(o => o.value === selectedOption.field)?.label ??
              'Relevance'
          }}
          onChange={value => value && onSortChangeHandler(value)}
          options={options}
        />
      </span>
    </div>
  );
};

export default SearchOverview;
